<template>
  <div v-if="item">
    <fields-list :item="item" :fields="fields" />
    <div class="save-group">
      <button class="btn btn-warning btn-icon" @click="updateItem">
        <span class="ti-save"></span>{{ "save" | setText("Сохранить") }}
      </button>
    </div>
  </div>
</template>

<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";

export default {
  data: () => ({
    cardLink: "partners",
    cardSetLink: "partners",
    item: null,
    fields: [
      {
        col: " col-12 col-md-6",
        key: "min_price",
        label: "Мин. цена",
        type: "field",
        textType: "number",
      },
      {
        col: " col-12 col-md-6",
        key: "max_price",
        label: "Макс. цена",
        type: "field",
        textType: "number",
      },
      {
        col: " col-12 col-md-6",
        key: "min_amount_product",
        label: "Мин. количество в заказе",
        type: "field",
        textType: "number",
      },
      {
        col: " col-12 col-md-6",
        key: "max_amount_product",
        label: "Макс. количество в заказе",
        type: "field",
        textType: "number",
      },
      {
        col: " col-12 col-md-12",
        key: "position",
        label: "Позиция",
        type: "field",
        textType: "number",
      },
      {
        col: " col-12 col-md-12",
        key: "is_active",
        label: "Активность",
        type: "checkbox",
      },
      {
        col: " col-12 col-md-6",
        key: "name",
        label: "Название",
        type: "field",
        textType: "text",
      },
      {
        col: " col-12 col-md-6",
        key: "tin",
        label: "ИНН",
        type: "field",
        textType: "text",
      },
      {
        col: " col-12 col-md-6",
        key: "phone",
        label: "Номер телефона",
        type: "field",
        textType: "text",
      },
      {
        col: " col-12 col-md-6",
        key: "code",
        label: "Ключ",
        type: "field",
        textType: "text",
      },
      {
        col: " col-12 col-md-12",
        key: "type_auth",
        label: "Тип авторизации",
        type: "field",
        textType: "text",
      },
      {
        col: " col-12 col-md-12",
        key: "api_secret_key",
        label: "Секретный ключ",
        type: "field",
        textType: "text",
      },
      {
        col: " col-12 col-md-12",
        key: "api_public_key",
        label: "Публичный ключ",
        type: "field",
        textType: "text",
      },
      {
        col: " col-12 col-md-12",
        key: "api_branch",
        labelKey: "api_branch",
        label: "Ветка",
        type: "field",
        textType: "text",
      },
      {
        col: " col-12 col-md-12",
        key: "endpoint_url",
        label: "Endpoint URL",
        type: "field",
        textType: "text",
      },
      {
        col: "col-12 col-md-6",
        label: "Логин",
        key: "api_login",
        type: "field",
      },
      {
        col: "col-12 col-md-6",
        label: "Пароль",
        key: "api_password",
        type: "field",
      },
    ],
  }),

  props: ["id"],
  async created() {
    // this.pushLang();
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(
        this.cardSetLink,
        this.item,
        this.fields
      );
      // if (item){
      //   this.item = item;
      // }
    },
  },
};
</script>
<style>
</style>
